const RF = {

  init: () => {

    RF.global.init()

    RF.checkPage('blog-page') && RF.blog.init()
  },

  global: {

    featuredBlogContainer: $('.rf-featured-blog-all'),
    iconWithTextSlider: $('.js-icon-with-text-slider'),
    iconSliderResizeBound: false,

    init: () => {

      RF.global.featuredBlogContainer.length && RF.blog.filterBlogArticles(RF.global.featuredBlogContainer, 1)
      RF.global.iconWithTextSlider.length && RF.global.iconsMobileSlider()

    },

    iconsMobileSlider: () => {

      const getBreakpointKey = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 768) return 'mobile';
        if (windowWidth < 992) return 'tablet';
        if (windowWidth < 1200) return 'mini_desktop';
        return 'desktop';
      };

      const buildOptions = (settings, breakpointKey) => {
        const slidesPerView = parseFloat(settings[`slides_${breakpointKey}`]) || 1;
        const spaceBetween = parseInt(settings[`space_${breakpointKey}`], 10) || 0;
        const centeredSlides = !!settings[`center_${breakpointKey}`];

        return {
          slidesPerView,
          loop: !!settings.loop,
          spaceBetween,
          centeredSlides,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          speed: parseInt(settings.speed, 10) || 500,
          autoplay: settings.autoplay ? {
            delay: parseInt(settings.delay, 10) || 5000,
            disableOnInteraction: false
          } : false,
          breakpoints: {
            768: {
              slidesPerView: parseFloat(settings.slides_tablet) || slidesPerView,
              spaceBetween: parseInt(settings.space_tablet, 10) || spaceBetween,
              centeredSlides: !!settings.center_tablet
            },
            992: {
              slidesPerView: parseFloat(settings.slides_mini_desktop) || slidesPerView,
              spaceBetween: parseInt(settings.space_mini_desktop, 10) || spaceBetween,
              centeredSlides: !!settings.center_mini_desktop
            },
            1200: {
              slidesPerView: parseFloat(settings.slides_desktop) || slidesPerView,
              spaceBetween: parseInt(settings.space_desktop, 10) || spaceBetween,
              centeredSlides: !!settings.center_desktop
            }
          }
        };
      };

      RF.global.iconWithTextSlider.each(function() {
        const el = this;
        const $el = $(this);
        const raw = $el.attr('data-rf-slider-options');

        if (!raw) return;

        let settings = null;
        try {
          settings = JSON.parse(raw);
        } catch (e) {
          console.error('RF Icon with text slider settings parse error', e);
          return;
        }

        const breakpointKey = getBreakpointKey();
        const shouldEnable = !!settings[`enable_${breakpointKey}`];

        if (el.swiper) {
          el.swiper.destroy(true, true);
        }

        if (shouldEnable) {
          new Swiper(el, buildOptions(settings, breakpointKey));
        }
      });

      if (!RF.global.iconSliderResizeBound) {
        let rfIconSliderResizeTimer = null;
        window.addEventListener('resize', () => {
          clearTimeout(rfIconSliderResizeTimer);
          rfIconSliderResizeTimer = setTimeout(() => {
            RF.global.iconsMobileSlider();
          }, 180);
        });
        RF.global.iconSliderResizeBound = true;
      }
    }
  },

  blog: {

    blogContainer: $('.rf-blogs-all'),
    blogPaginationContainer: $('.rf-blogs-all-pagination'),

    init: () => {

      if (RF.blog.blogContainer.length && RF.blog.blogPaginationContainer.length) {

        const params = new URLSearchParams(window.location.search)
        const page = parseInt(params.get('blog_page')) || 1

        RF.blog.filterBlogArticles(RF.blog.blogContainer, page)
        RF.blog.appendPagination(RF.blog.blogPaginationContainer, page)
      }
    },

    filterBlogArticles: (container, page) => {

      if (!container.length) {
        console.error('Container NOT found')
        return
      }

      const articlesCount = parseInt(container.data('articles_to_show'))
      const blogItems = container.find('.blog-item').toArray()

      blogItems.sort((a, b) => RF.blog.extractArticleTimestamp(b) - RF.blog.extractArticleTimestamp(a))

      const startIndex = (page - 1) * articlesCount
      const endIndex = startIndex + articlesCount

      container.empty()

      $(blogItems).slice(startIndex, endIndex).appendTo(container)

      container.removeClass('d-none')
    },

    appendPagination: (container, page) => {

      const totalPages = parseInt(container.data('total_pages'));

      let startPage = page - 2;
      let endPage = page + 2;

      if (startPage < 2) startPage = 2;
      if (endPage > totalPages) endPage = totalPages;

      if (page > 1) {
        container.append(`<a href="?blog_page=${page - 1}" class="page-numbers prev" aria-label="Previous page"><i class="feather-chevron-left"></i></a>`);
      }

      container.append(`<a href="?blog_page=1" class="page-numbers ${page === 1 ? 'current' : ''}" aria-label="Page 1">1</a>`);

      if (page > 4) {
        container.append(`<span class="page-numbers">…</span>`);
      }

      for (let i = startPage; i <= endPage; i++) {
        container.append(`<a href="?blog_page=${i}" class="page-numbers ${page === i ? 'current' : ''}" aria-label="Page ${i}">${i}</a>`);
      }

      if (page < totalPages - 3) {
        container.append(`<span class="page-numbers">…</span>`);
      }

      if (page < totalPages - 2) {

        container.append(`<a href="?blog_page=${totalPages}" class="page-numbers ${page === totalPages ? 'current' : ''}" aria-label="Page ${totalPages}">${totalPages}</a>`);
      }

      if (page < totalPages) {

        container.append(`<a href="?blog_page=${page + 1}" class="page-numbers next" aria-label="Next page"><i class="feather-chevron-right"></i></a>`);
      }

      container.removeClass('d-none');
    },

    extractArticleTimestamp: article => {

      return Date.parse($(article).find('.blog-meta-wrap span').text().trim())
    }
  },

  checkPage: pageClass => $('body').hasClass(pageClass),
}

$(document).ready(function () {

  RF.init();
});
